// apps/web-app/src/tracking.ts
import { createTracker } from '@saas/lib/tracking-core';
import { createPosthogWebAdapter } from '@saas/lib/tracking-posthog-web';

const isTrackingEnabled = window._env_.REACT_APP_TTD_ENV === 'production';

const adapter = createPosthogWebAdapter({
  apiKey: window._env_.REACT_APP_TRACKING_API_KEY,
  apiHost: window._env_.REACT_APP_TRACKING_API_HOST || "https://eu.i.posthog.com"
});

export const tracker = createTracker(adapter, isTrackingEnabled);
